import { render, staticRenderFns } from "./AscAlertLabel.vue?vue&type=template&id=4f329515&scoped=true&"
import script from "./AscAlertLabel.vue?vue&type=script&lang=js&"
export * from "./AscAlertLabel.vue?vue&type=script&lang=js&"
import style0 from "./AscAlertLabel.vue?vue&type=style&index=0&id=4f329515&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f329515",
  null
  
)

export default component.exports